($ => {


    if( $('[data-strip-group-item="buttons"]').length ) {

        $('[data-strip-buy-button]').click(function(e) {
            e.preventDefault()
            $('[data-strip-group-item="init"]').removeClass('is-active')
            $('[data-strip-group-item="buttons"]').addClass('is-active')
        })

    }


})(jQuery)